import React from 'react';
import {withNamespaces} from "react-i18next";
import {isEmpty} from "lodash";
import Select from 'react-select'

const HikeSelect = ({  t, hikes, theme, hike, onSelect }) =>
    hikes.length > 0 ?
    <Select
        value={!isEmpty(hike) ? hike : null}
        onChange={(hike) => onSelect(hike.value)}
        id="hike"
        placeholder="Chargement en cours..."
        clearable={false}
        options={hikes.map((current)=> ({value: current.slug, label: current.title}))}>
    </Select> :
        <input className="form-control" readOnly={true} placeholder="Chargement en cours..." />
;

export default withNamespaces()(HikeSelect);
